define('views/layouts/layout-loading',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // models
    'models/member/group',
    // template
    'text!templates/layouts/layout-loading.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // models
    MGroup,
    // template
    TLayoutLoading
) {

    var VLayoutLoading = Backbone.View.extend({
        className: "loading-layout",
        template: TLayoutLoading,
        initialize: function() {
            this.model = new MGroup(User.getMainGroup());
            this.listenTo(User, 'sync model:reset change:_mainGroup', this.onUserChange);
            this.listenTo(this.model, 'change:logo', this.render);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                isText: this.model.isLogoText(),
                logoData: this.model.get('logoData')
            })));
            return this;
        },

        toggle: function(value) {
            this.$el.toggleClass('hidden', _.isUndefined(value) ? value : !value);
        },

        onUserChange: function() {
            this.model.reset(User.getMainGroup());
        },

    });

    return VLayoutLoading;
});

